<template>
  <div class="grow">
    <div v-if="booking && allocation">
      <h2>
        {{ t('returnOverview') }}
      </h2>

      <BasicReturnOverview :booking="booking" />

      <Divider />

      <VehicleAndTimes :booking-or-allocation="allocation" :car="allocation.car" />

      <Divider />

      <div class="flex justify-end">
        <ButtonNext @click.prevent="handleNext">{{ t('next') }}</ButtonNext>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import VehicleAndTimes from '@/components/booking-forms/VehicleAndTimes.vue';
import ButtonNext from '@/components/buttons/ButtonNext.vue';
import Divider from '@/components/Divider.vue';
import { useI18n } from 'vue-i18n';
import { useBooking } from '@/queries/use-bookings';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import BasicReturnOverview from './components/BasicReturnOverview.vue';
import { useProcessNavigation } from '@/hooks/use-process-step-tracking';

const { t } = useI18n();
const route = useRoute();
const { goToNext } = useProcessNavigation();

const { data: booking } = useBooking(route.params.id as string);
const allocation = computed(() => booking.value?.allocations[booking.value.allocations.length - 1]);

const handleNext = async () => {
  if (!booking.value) return;
  goToNext();
};
</script>

<i18n lang="json">
{
  "en": {
    "returnOverview": "Return overview",
    "back": "return to upcoming handovers",
    "next": "next"
  },
  "de": {
    "back": "Zurück zur Übergabeliste",
    "next": "Weiter",
    "returnOverview": "Rückgabeübersicht"
  },
  "es": {
    "returnOverview": "Vista general de la devolución",
    "back": "volver a entregas y devoluciones",
    "next": "siguiente"
  }
}
</i18n>
